import React, { useState } from 'react';
import { X } from 'lucide-react';
import '../styles/privacy.css';

const PrivacyPolicyModal = ({ isOpen, onClose }) => {
  if (!isOpen) return null;

  return (
    <div className="privacy-modal-overlay" onClick={onClose}>
      <div className="privacy-modal-content" onClick={(e) => e.stopPropagation()}>
        <div className="privacy-modal-header">
          <h2 className="privacy-modal-title">Privacy Policy</h2>
          <button className="privacy-modal-close" onClick={onClose} aria-label="Close">
            <X size={24} />
          </button>
        </div>
        <div className="privacy-modal-body">
          <div className="privacy-section">
            <h3>Introduction</h3>
            <p>
              APK FINTECH Private Limited ("we," "us," or "our") is committed to protecting your privacy. 
              This Privacy Policy explains how we collect, use, disclose, and safeguard your information when 
              you visit our website and use our services.
            </p>
          </div>

          <div className="privacy-section">
            <h3>Information We Collect</h3>
            <h4>Personal Information</h4>
            <p>
              We may collect personal information that you voluntarily provide to us when you:
            </p>
            <ul>
              <li>Register for our services</li>
              <li>Fill out contact forms</li>
              <li>Subscribe to our newsletter</li>
              <li>Use our mobile application</li>
              <li>Communicate with us</li>
            </ul>
            <p>This information may include:</p>
            <ul>
              <li>Name and contact information (email, phone number, address)</li>
              <li>Financial information (income, investment preferences, PAN details)</li>
              <li>Identity verification documents</li>
              <li>Bank account details</li>
              <li>Investment portfolio information</li>
            </ul>
          </div>

          <div className="privacy-section">
            <h3>How We Use Your Information</h3>
            <p>We use the information we collect to:</p>
            <ul>
              <li>Provide and maintain our investment advisory services</li>
              <li>Process your transactions and investments</li>
              <li>Communicate with you about your portfolio and our services</li>
              <li>Comply with legal and regulatory requirements</li>
              <li>Improve our services and customer experience</li>
              <li>Send you marketing communications (with your consent)</li>
              <li>Detect and prevent fraud</li>
              <li>Respond to your inquiries and support requests</li>
            </ul>
          </div>

          <div className="privacy-section">
            <h3>Information Sharing and Disclosure</h3>
            <p>We may share your information with:</p>
            <ul>
              <li><strong>Service Providers:</strong> Third-party companies that help us operate our business (payment processors, KYC verification services, etc.)</li>
              <li><strong>Regulatory Bodies:</strong> SEBI, RBI, and other regulatory authorities as required by law</li>
              <li><strong>Financial Institutions:</strong> Mutual fund houses, PMS providers, AIF managers for processing your investments</li>
              <li><strong>Legal Requirements:</strong> When required by law or to protect our rights</li>
            </ul>
            <p>We do not sell your personal information to third parties.</p>
          </div>

          <div className="privacy-section">
            <h3>Data Security</h3>
            <p>
              We implement appropriate technical and organizational security measures to protect your personal 
              information against unauthorized access, alteration, disclosure, or destruction. However, no method 
              of transmission over the internet or electronic storage is 100% secure.
            </p>
          </div>

          <div className="privacy-section">
            <h3>Data Retention</h3>
            <p>
              We retain your personal information for as long as necessary to fulfill the purposes outlined in 
              this Privacy Policy, unless a longer retention period is required by law or regulation.
            </p>
          </div>

          <div className="privacy-section">
            <h3>Your Rights</h3>
            <p>You have the right to:</p>
            <ul>
              <li>Access your personal information</li>
              <li>Correct inaccurate information</li>
              <li>Request deletion of your information (subject to legal requirements)</li>
              <li>Opt-out of marketing communications</li>
              <li>Withdraw consent for data processing</li>
            </ul>
          </div>

          <div className="privacy-section">
            <h3>Cookies and Tracking Technologies</h3>
            <p>
              We use cookies and similar tracking technologies to enhance your experience on our website. 
              You can control cookie settings through your browser preferences.
            </p>
          </div>

          <div className="privacy-section">
            <h3>Third-Party Links</h3>
            <p>
              Our website may contain links to third-party websites. We are not responsible for the privacy 
              practices of these external sites.
            </p>
          </div>

          <div className="privacy-section">
            <h3>Changes to This Privacy Policy</h3>
            <p>
              We may update this Privacy Policy from time to time. We will notify you of any changes by 
              posting the new Privacy Policy on this page and updating the "Last Updated" date.
            </p>
          </div>

          <div className="privacy-section">
            <h3>Contact Us</h3>
            <p>
              If you have any questions about this Privacy Policy or our data practices, please contact us:
            </p>
            <ul>
              <li><strong>Email:</strong> info@apkfintech.com</li>
              <li><strong>Phone:</strong> +91 9828095549</li>
              <li><strong>Address:</strong> Mumbai, Maharashtra, India</li>
            </ul>
          </div>

          <div className="privacy-section">
            <p className="privacy-last-updated">
              <strong>Last Updated:</strong> February 2025
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicyModal;
